export function getUninstallableReason(appInstallability) {
  const {
    installed,
    incompatibleHubInstalls,
    incompatibleHubUserInstalls,
    missingHubUserRoles,
    missingHubScopes,
    missingHubScopeGroups
  } = appInstallability;
  if (installed) {
    return {
      label: 'ALREADY_INSTALLED'
    };
  }
  if (missingHubUserRoles.length && !missingHubScopes.length) {
    return {
      label: 'MISSING_USER_PERMISSIONS',
      missingHubUserRoles
    };
  }
  if (missingHubScopes.length || missingHubScopeGroups.length) {
    const missingScopes = missingHubScopes.length ? missingHubScopes : missingHubScopeGroups;
    return {
      label: 'MISSING_HUB_SCOPES',
      missingScopes
    };
  }
  if (incompatibleHubInstalls.length || incompatibleHubUserInstalls.length) {
    const incompatibleInstalls = incompatibleHubInstalls.length ? incompatibleHubInstalls : incompatibleHubUserInstalls;
    return {
      label: 'INCOMPATIBLE_INSTALLS',
      incompatibleInstalls
    };
  }
}